import Mutations from '../../odata/mutations';

export default { ...new Mutations('division'), ...new Mutations('divisions') };
